<script setup lang="ts">
import TransferWorkspace from '@/components/stock-transfer/TransferWorkspace.vue';
// Static routes (`new`, `settings`) outrank the dynamic `:id` route; `/create` stays as an alias.
definePage({ alias: ['/warehouse/stock-transfers/create'] });
</script>
<template><TransferWorkspace /></template>
